// extracted by mini-css-extract-plugin
module.exports = {"rootLayout":"App_rootLayout__1JQHC","contentLayout":"App_contentLayout__1ey6t"};